import { Injectable, inject } from '@angular/core';
import { PortalContextProvider } from '@core';
import { PortalType } from '@shared';
import { StatusState } from '../../states/status.state';
import { GetStatusesStateResult } from './get-statuses-state.result';

@Injectable()
export class GetStatusesStateUseCase {
  private readonly state = inject(StatusState);
  private readonly portalContext = inject(PortalContextProvider);

  execute(): GetStatusesStateResult {
    const isCases = this.portalContext.currentPortalType() === PortalType.Cases;

    return {
      statuses: isCases ? this.state.casesStatuses : this.state.investigationsStatuses,
      loading: this.state.loading,
      error: this.state.error,
      statusesCount: isCases ? this.state.casesStatusesCount : this.state.investigationsStatusesCount,
      hasStatuses: isCases ? this.state.hasCasesStatuses : this.state.hasInvestigationsStatuses,
      categories: this.state.categories,
      categoriesLoading: this.state.categoriesLoading,
      categoriesError: this.state.categoriesError,
      selectedStatus: this.state.selectedStatus,
      detailLoading: this.state.detailLoading,
      saving: this.state.saving,
      errorSavingStatus: this.state.errorSavingStatus,
      savingStatusActive: this.state.savingStatusActive,
      isDeletingStatus: this.state.isDeletingStatus,
    };
  }
}
